/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * pictory Client API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


import * as url from "url";
import portableFetch from "portable-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "http://localhost:8080".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *  
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 * 
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = portableFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
};

/**
 * 
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name: "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 * @interface AddressDto
 */
export interface AddressDto {
    /**
     * ignored as input
     * @type {number}
     * @memberof AddressDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    line1?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    street?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    houseNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof AddressDto
     */
    postalCode?: number;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    country?: AddressDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof AddressDto
     */
    institution?: string;
}

/**
 * @export
 * @namespace AddressDto
 */
export namespace AddressDto {
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        AUSTRIA = <any> 'AUSTRIA',
        GERMANY = <any> 'GERMANY',
        BOSNIA = <any> 'BOSNIA'
    }
}

/**
 * 
 * @export
 * @interface BankAccountDataDto
 */
export interface BankAccountDataDto {
    /**
     * 
     * @type {string}
     * @memberof BankAccountDataDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDataDto
     */
    iban?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDataDto
     */
    bic?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDataDto
     */
    accountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDataDto
     */
    bankAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccountDataDto
     */
    purpose?: string;
    /**
     * 
     * @type {number}
     * @memberof BankAccountDataDto
     */
    amount?: number;
}

/**
 * 
 * @export
 * @interface BasketDto
 */
export interface BasketDto {
    /**
     * 
     * @type {Array<BasketPositionDto>}
     * @memberof BasketDto
     */
    positions?: Array<BasketPositionDto>;
    /**
     * 
     * @type {number}
     * @memberof BasketDto
     */
    positionCount?: number;
    /**
     * 
     * @type {number}
     * @memberof BasketDto
     */
    subtotal?: number;
    /**
     * 
     * @type {number}
     * @memberof BasketDto
     */
    shipping?: number;
    /**
     * 
     * @type {number}
     * @memberof BasketDto
     */
    vat?: number;
    /**
     * 
     * @type {number}
     * @memberof BasketDto
     */
    discount?: number;
    /**
     * 
     * @type {number}
     * @memberof BasketDto
     */
    totalPrice?: number;
    /**
     * 
     * @type {number}
     * @memberof BasketDto
     */
    shippingMethodId?: number;
    /**
     * 
     * @type {Array<ShippingMethodDto>}
     * @memberof BasketDto
     */
    shippingMethods?: Array<ShippingMethodDto>;
}

/**
 * 
 * @export
 * @interface BasketPositionDto
 */
export interface BasketPositionDto {
    /**
     * 
     * @type {number}
     * @memberof BasketPositionDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof BasketPositionDto
     */
    amount?: number;
    /**
     * 
     * @type {number}
     * @memberof BasketPositionDto
     */
    totalPrice?: number;
    /**
     * 
     * @type {ConfiguredProductDto}
     * @memberof BasketPositionDto
     */
    product?: ConfiguredProductDto;
}

/**
 * 
 * @export
 * @interface ChangeShippingMethodData
 */
export interface ChangeShippingMethodData {
    /**
     * 
     * @type {number}
     * @memberof ChangeShippingMethodData
     */
    shippingMethodId?: number;
}

/**
 * 
 * @export
 * @interface ConfiguredImageDto
 */
export interface ConfiguredImageDto {
    /**
     * 
     * @type {number}
     * @memberof ConfiguredImageDto
     */
    imageId?: number;
    /**
     * 
     * @type {number}
     * @memberof ConfiguredImageDto
     */
    imageCropId?: number;
    /**
     * 
     * @type {string}
     * @memberof ConfiguredImageDto
     */
    uniqueImageId?: string;
    /**
     * 
     * @type {number}
     * @memberof ConfiguredImageDto
     */
    productId?: number;
    /**
     * 
     * @type {ImageFilterDto}
     * @memberof ConfiguredImageDto
     */
    filter?: ImageFilterDto;
}

/**
 * 
 * @export
 * @interface ConfiguredProductDto
 */
export interface ConfiguredProductDto {
    /**
     * 
     * @type {number}
     * @memberof ConfiguredProductDto
     */
    productId: number;
    /**
     * 
     * @type {Array<ConfiguredImageDto>}
     * @memberof ConfiguredProductDto
     */
    images?: Array<ConfiguredImageDto>;
    /**
     * If true, an image has to be configured for every product which is contained in the set-product
     * @type {boolean}
     * @memberof ConfiguredProductDto
     */
    detailedConfiguration?: boolean;
}

/**
 * 
 * @export
 * @interface CouponDto
 */
export interface CouponDto {
    /**
     * 
     * @type {CouponTypeDto}
     * @memberof CouponDto
     */
    type?: CouponTypeDto;
    /**
     * 
     * @type {number}
     * @memberof CouponDto
     */
    discount?: number;
    /**
     * 
     * @type {number}
     * @memberof CouponDto
     */
    minimumValue?: number;
    /**
     * 
     * @type {string}
     * @memberof CouponDto
     */
    activeUntil?: string;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum CouponTypeDto {
    VALUE = <any> 'VALUE',
    PERCENTAGE = <any> 'PERCENTAGE',
    FREESHIPPING = <any> 'FREE_SHIPPING'
}

/**
 * 
 * @export
 * @interface CustomerProfileDto
 */
export interface CustomerProfileDto {
    /**
     * 
     * @type {string}
     * @memberof CustomerProfileDto
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerProfileDto
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof CustomerProfileDto
     */
    email?: string;
}

/**
 * 
 * @export
 * @interface DeletePositionData
 */
export interface DeletePositionData {
    /**
     * 
     * @type {number}
     * @memberof DeletePositionData
     */
    positionId?: number;
}

/**
 * 
 * @export
 * @interface DetailedImageRequirementDto
 */
export interface DetailedImageRequirementDto {
    /**
     * 
     * @type {number}
     * @memberof DetailedImageRequirementDto
     */
    productId?: number;
    /**
     * 
     * @type {string}
     * @memberof DetailedImageRequirementDto
     */
    productName?: string;
    /**
     * 
     * @type {ProductMediumDto}
     * @memberof DetailedImageRequirementDto
     */
    productMedium?: ProductMediumDto;
    /**
     * 
     * @type {string}
     * @memberof DetailedImageRequirementDto
     */
    productImageUrl?: string;
    /**
     * 
     * @type {ImageFilterDto}
     * @memberof DetailedImageRequirementDto
     */
    productFilter?: ImageFilterDto;
    /**
     * 
     * @type {ImageRequirementDto}
     * @memberof DetailedImageRequirementDto
     */
    requirement?: ImageRequirementDto;
}

/**
 * 
 * @export
 * @interface EditPositionAmountData
 */
export interface EditPositionAmountData {
    /**
     * 
     * @type {number}
     * @memberof EditPositionAmountData
     */
    positionId?: number;
    /**
     * 
     * @type {number}
     * @memberof EditPositionAmountData
     */
    amount?: number;
}

/**
 * 
 * @export
 * @interface ErrorDto
 */
export interface ErrorDto {
    /**
     * 
     * @type {string}
     * @memberof ErrorDto
     */
    message?: string;
}

/**
 * 
 * @export
 * @interface ImageCollectionDto
 */
export interface ImageCollectionDto {
    /**
     * 
     * @type {Array<ImageDto>}
     * @memberof ImageCollectionDto
     */
    images?: Array<ImageDto>;
    /**
     * 
     * @type {Array<PersonDto>}
     * @memberof ImageCollectionDto
     */
    persons?: Array<PersonDto>;
}

/**
 * 
 * @export
 * @interface ImageDto2
 */
export interface ImageDto2 {
    /**
     * 
     * @type {number}
     * @memberof ImageDto2
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ImageDto2
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageDto2
     */
    smallUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageDto2
     */
    mediumUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageDto2
     */
    largeUrl?: string;
    /**
     * 
     * @type {ImageOrientationDto}
     * @memberof ImageDto2
     */
    orientation?: ImageOrientationDto;
    /**
     * 
     * @type {ImageTypeDto}
     * @memberof ImageDto2
     */
    type?: ImageTypeDto;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ImageFilterDto {
    NONE = <any> 'NONE',
    GRAYSCALE = <any> 'GRAYSCALE',
    SEPIA = <any> 'SEPIA'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ImageOrientationDto {
    LANDSCAPE = <any> 'LANDSCAPE',
    PORTRAIT = <any> 'PORTRAIT'
}

/**
 * 
 * @export
 * @interface ImageRequirementDto
 */
export interface ImageRequirementDto {
    /**
     * 
     * @type {Array<ImageTypeDto>}
     * @memberof ImageRequirementDto
     */
    types?: Array<ImageTypeDto>;
    /**
     * 
     * @type {Array<ImageOrientationDto>}
     * @memberof ImageRequirementDto
     */
    orientations?: Array<ImageOrientationDto>;
    /**
     * 
     * @type {string}
     * @memberof ImageRequirementDto
     */
    type?: ImageRequirementDto.TypeEnum;
}

/**
 * @export
 * @namespace ImageRequirementDto
 */
export namespace ImageRequirementDto {
    /**
     * @export
     * @enum {string}
     */
    export enum TypeEnum {
        SINGLE = <any> 'SINGLE',
        ALLOFPERSON = <any> 'ALL_OF_PERSON'
    }
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ImageTypeDto {
    SINGLE = <any> 'SINGLE',
    FRIEND = <any> 'FRIEND',
    GROUP = <any> 'GROUP'
}

/**
 * 
 * @export
 * @interface OrderConfirmationDto
 */
export interface OrderConfirmationDto {
    /**
     * 
     * @type {boolean}
     * @memberof OrderConfirmationDto
     */
    success?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrderConfirmationDto
     */
    tryAgain?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderConfirmationDto
     */
    orderId?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderConfirmationDto
     */
    orderToken?: string;
    /**
     * 
     * @type {string}
     * @memberof OrderConfirmationDto
     */
    downloadCode?: string;
    /**
     * 
     * @type {BankAccountDataDto}
     * @memberof OrderConfirmationDto
     */
    bankAccount?: BankAccountDataDto;
    /**
     * 
     * @type {StripePaymentInformationDto}
     * @memberof OrderConfirmationDto
     */
    stripePayment?: StripePaymentInformationDto;
    /**
     * 
     * @type {any}
     * @memberof OrderConfirmationDto
     */
    redirectUrl?: any;
    /**
     * 
     * @type {number}
     * @memberof OrderConfirmationDto
     */
    totalAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof OrderConfirmationDto
     */
    language?: string;
    /**
     * 
     * @type {PaymentMethodDto}
     * @memberof OrderConfirmationDto
     */
    paymentMethod?: PaymentMethodDto;
    /**
     * 
     * @type {string}
     * @memberof OrderConfirmationDto
     */
    envelopeInstructions?: string;
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum PaymentMethodDto {
    BANKTRANSFER = <any> 'BANK_TRANSFER',
    SOFORT = <any> 'SOFORT',
    EPS = <any> 'EPS',
    CREDITCARD = <any> 'CREDIT_CARD',
    KLARNANOW = <any> 'KLARNA_NOW',
    KLARNALATER = <any> 'KLARNA_LATER',
    APPLEPAY = <any> 'APPLE_PAY',
    GOOGLEPAY = <any> 'GOOGLE_PAY',
    PAYPAL = <any> 'PAYPAL',
    CASHENVELOPE = <any> 'CASH_ENVELOPE'
}

/**
 * 
 * @export
 * @interface PersonDto
 */
export interface PersonDto {
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonDto
     */
    expiryDate?: string;
    /**
     * An array of the person's unique image IDs
     * @type {Array<string>}
     * @memberof PersonDto
     */
    imageIds?: Array<string>;
    /**
     * The products this person has permission for to order
     * @type {Array<number>}
     * @memberof PersonDto
     */
    productIds?: Array<number>;
}

/**
 * 
 * @export
 * @interface PlaceOrderData
 */
export interface PlaceOrderData {
    /**
     * 
     * @type {AddressDto}
     * @memberof PlaceOrderData
     */
    deliveryAddress?: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof PlaceOrderData
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceOrderData
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof PlaceOrderData
     */
    comment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PlaceOrderData
     */
    newsletterConsent?: boolean;
    /**
     * 
     * @type {PaymentMethodDto}
     * @memberof PlaceOrderData
     */
    paymentMethod?: PaymentMethodDto;
    /**
     * 
     * @type {number}
     * @memberof PlaceOrderData
     */
    shippingMethodId?: number;
    /**
     * Selected language locale code (e.g. de, en, bs)
     * @type {string}
     * @memberof PlaceOrderData
     */
    language?: string;
}

/**
 * 
 * @export
 * @interface ProductCategoryDto
 */
export interface ProductCategoryDto {
    /**
     * 
     * @type {number}
     * @memberof ProductCategoryDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductCategoryDto
     */
    order?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductCategoryDto
     */
    iconName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductCategoryDto
     */
    highlight?: boolean;
}

/**
 * 
 * @export
 * @interface ProductDto2
 */
export interface ProductDto2 {
    /**
     * 
     * @type {number}
     * @memberof ProductDto2
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDto2
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductDto2
     */
    order?: number;
    /**
     * Link to the product picture
     * @type {string}
     * @memberof ProductDto2
     */
    imageUrl?: string;
    /**
     * 
     * @type {ProductMediumDto}
     * @memberof ProductDto2
     */
    medium?: ProductMediumDto;
    /**
     * 
     * @type {ProductTypeDto}
     * @memberof ProductDto2
     */
    productType?: ProductTypeDto;
    /**
     * 
     * @type {string}
     * @memberof ProductDto2
     */
    downloadType?: ProductDto2.DownloadTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProductDto2
     */
    subHeading?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductDto2
     */
    price?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDto2
     */
    highlight?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDto2
     */
    gift?: boolean;
    /**
     * 
     * @type {ImageFilterDto}
     * @memberof ProductDto2
     */
    imageFilter?: ImageFilterDto;
    /**
     * 
     * @type {string}
     * @memberof ProductDto2
     */
    shortDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto2
     */
    longDescription?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductDto2
     */
    detailedConfigurationSurcharge?: number;
}

/**
 * @export
 * @namespace ProductDto2
 */
export namespace ProductDto2 {
    /**
     * @export
     * @enum {string}
     */
    export enum DownloadTypeEnum {
        SINGLE = <any> 'SINGLE',
        ALL = <any> 'ALL'
    }
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ProductMediumDto {
    PRINT = <any> 'PRINT',
    DOWNLOAD = <any> 'DOWNLOAD'
}

/**
 * 
 * @export
 * @enum {string}
 */
export enum ProductTypeDto {
    SINGLEPICTURE = <any> 'SINGLE_PICTURE',
    SET = <any> 'SET'
}

/**
 * 
 * @export
 * @interface RedeemCodesData
 */
export interface RedeemCodesData {
    /**
     * 
     * @type {Array<string>}
     * @memberof RedeemCodesData
     */
    codes?: Array<string>;
}

/**
 * 
 * @export
 * @interface RegisterPaymentSourceData
 */
export interface RegisterPaymentSourceData {
    /**
     * 
     * @type {number}
     * @memberof RegisterPaymentSourceData
     */
    orderId?: number;
    /**
     * 
     * @type {string}
     * @memberof RegisterPaymentSourceData
     */
    sourceId?: string;
}

/**
 * 
 * @export
 * @interface ShippingMethodDto
 */
export interface ShippingMethodDto {
    /**
     * 
     * @type {number}
     * @memberof ShippingMethodDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShippingMethodDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ShippingMethodDto
     */
    price?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ShippingMethodDto
     */
    available?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShippingMethodDto
     */
    unavailableReasonProductNames?: Array<string>;
}

/**
 * 
 * @export
 * @interface StripePaymentInformationDto
 */
export interface StripePaymentInformationDto {
    /**
     * 
     * @type {string}
     * @memberof StripePaymentInformationDto
     */
    paymentIntentSecret?: string;
}

/**
 * 
 * @export
 * @interface VerifyPaymentDataDto
 */
export interface VerifyPaymentDataDto {
    /**
     * 
     * @type {string}
     * @memberof VerifyPaymentDataDto
     */
    orderToken?: string;
    /**
     * 
     * @type {string}
     * @memberof VerifyPaymentDataDto
     */
    paymentIntent?: string;
    /**
     * 
     * @type {string}
     * @memberof VerifyPaymentDataDto
     */
    paymentSource?: string;
}

/**
 * 
 * @export
 * @interface ImageDto
 */
export interface ImageDto {
    /**
     * 
     * @type {number}
     * @memberof ImageDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ImageDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageDto
     */
    smallUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageDto
     */
    mediumUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ImageDto
     */
    largeUrl?: string;
    /**
     * 
     * @type {ImageOrientationDto}
     * @memberof ImageDto
     */
    orientation?: ImageOrientationDto;
    /**
     * 
     * @type {ImageTypeDto}
     * @memberof ImageDto
     */
    type?: ImageTypeDto;
    /**
     * Includes the image id and the variant
     * @type {string}
     * @memberof ImageDto
     */
    uniqueId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ImageDto
     */
    favorite?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ImageDto
     */
    imageCropId?: number;
    /**
     * 
     * @type {string}
     * @memberof ImageDto
     */
    label?: string;
}

/**
 * 
 * @export
 * @interface ProductDto
 */
export interface ProductDto {
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    order?: number;
    /**
     * Link to the product picture
     * @type {string}
     * @memberof ProductDto
     */
    imageUrl?: string;
    /**
     * 
     * @type {ProductMediumDto}
     * @memberof ProductDto
     */
    medium?: ProductMediumDto;
    /**
     * 
     * @type {ProductTypeDto}
     * @memberof ProductDto
     */
    productType?: ProductTypeDto;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    downloadType?: ProductDto.DownloadTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    subHeading?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    price?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDto
     */
    highlight?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductDto
     */
    gift?: boolean;
    /**
     * 
     * @type {ImageFilterDto}
     * @memberof ProductDto
     */
    imageFilter?: ImageFilterDto;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    shortDescription?: string;
    /**
     * 
     * @type {string}
     * @memberof ProductDto
     */
    longDescription?: string;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    detailedConfigurationSurcharge?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductDto
     */
    containedIn?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof ProductDto
     */
    setPriceInsteadOf?: number;
    /**
     * 
     * @type {Array<ImageRequirementDto>}
     * @memberof ProductDto
     */
    imageRequirements?: Array<ImageRequirementDto>;
    /**
     * 
     * @type {Array<DetailedImageRequirementDto>}
     * @memberof ProductDto
     */
    detailedImageRequirements?: Array<DetailedImageRequirementDto>;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductDto
     */
    categoryIds?: Array<number>;
}

/**
 * @export
 * @namespace ProductDto
 */
export namespace ProductDto {
    /**
     * @export
     * @enum {string}
     */
    export enum DownloadTypeEnum {
        SINGLE = <any> 'SINGLE',
        ALL = <any> 'ALL'
    }
}


/**
 * BasketApi - fetch parameter creator
 * @export
 */
export const BasketApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Adds the given item to the basket
         * @param {ConfiguredProductDto} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProduct(data?: ConfiguredProductDto, options: any = {}): FetchArgs {
            const localVarPath = `/api/basket/add`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ConfiguredProductDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(data || {}) : (data || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ChangeShippingMethodData} [changeShippingMethodData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeShippingMethod(changeShippingMethodData?: ChangeShippingMethodData, options: any = {}): FetchArgs {
            const localVarPath = `/api/basket/changeShippingMethod`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ChangeShippingMethodData" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(changeShippingMethodData || {}) : (changeShippingMethodData || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Removes the given position from the basket
         * @param {DeletePositionData} [deletePositionData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePosition(deletePositionData?: DeletePositionData, options: any = {}): FetchArgs {
            const localVarPath = `/api/basket/deletePosition`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"DeletePositionData" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(deletePositionData || {}) : (deletePositionData || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edits the given position's amount
         * @param {EditPositionAmountData} [editPositionAmountData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editPositionAmount(editPositionAmountData?: EditPositionAmountData, options: any = {}): FetchArgs {
            const localVarPath = `/api/basket/editPositionAmount`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"EditPositionAmountData" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(editPositionAmountData || {}) : (editPositionAmountData || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns an object containing all information about the user's basket
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasket(options: any = {}): FetchArgs {
            const localVarPath = `/api/basket`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BasketApi - functional programming interface
 * @export
 */
export const BasketApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Adds the given item to the basket
         * @param {ConfiguredProductDto} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProduct(data?: ConfiguredProductDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BasketDto> {
            const localVarFetchArgs = BasketApiFetchParamCreator(configuration).addProduct(data, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ChangeShippingMethodData} [changeShippingMethodData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeShippingMethod(changeShippingMethodData?: ChangeShippingMethodData, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BasketDto> {
            const localVarFetchArgs = BasketApiFetchParamCreator(configuration).changeShippingMethod(changeShippingMethodData, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Removes the given position from the basket
         * @param {DeletePositionData} [deletePositionData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePosition(deletePositionData?: DeletePositionData, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BasketDto> {
            const localVarFetchArgs = BasketApiFetchParamCreator(configuration).deletePosition(deletePositionData, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Edits the given position's amount
         * @param {EditPositionAmountData} [editPositionAmountData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editPositionAmount(editPositionAmountData?: EditPositionAmountData, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BasketDto> {
            const localVarFetchArgs = BasketApiFetchParamCreator(configuration).editPositionAmount(editPositionAmountData, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Returns an object containing all information about the user's basket
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasket(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<BasketDto> {
            const localVarFetchArgs = BasketApiFetchParamCreator(configuration).getBasket(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * BasketApi - factory interface
 * @export
 */
export const BasketApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Adds the given item to the basket
         * @param {ConfiguredProductDto} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProduct(data?: ConfiguredProductDto, options?: any) {
            return BasketApiFp(configuration).addProduct(data, options)(fetch, basePath);
        },
        /**
         * 
         * @param {ChangeShippingMethodData} [changeShippingMethodData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeShippingMethod(changeShippingMethodData?: ChangeShippingMethodData, options?: any) {
            return BasketApiFp(configuration).changeShippingMethod(changeShippingMethodData, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Removes the given position from the basket
         * @param {DeletePositionData} [deletePositionData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePosition(deletePositionData?: DeletePositionData, options?: any) {
            return BasketApiFp(configuration).deletePosition(deletePositionData, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Edits the given position's amount
         * @param {EditPositionAmountData} [editPositionAmountData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editPositionAmount(editPositionAmountData?: EditPositionAmountData, options?: any) {
            return BasketApiFp(configuration).editPositionAmount(editPositionAmountData, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Returns an object containing all information about the user's basket
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBasket(options?: any) {
            return BasketApiFp(configuration).getBasket(options)(fetch, basePath);
        },
    };
};

/**
 * BasketApi - object-oriented interface
 * @export
 * @class BasketApi
 * @extends {BaseAPI}
 */
export class BasketApi extends BaseAPI {
    /**
     * 
     * @summary Adds the given item to the basket
     * @param {ConfiguredProductDto} [data] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasketApi
     */
    public addProduct(data?: ConfiguredProductDto, options?: any) {
        return BasketApiFp(this.configuration).addProduct(data, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ChangeShippingMethodData} [changeShippingMethodData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasketApi
     */
    public changeShippingMethod(changeShippingMethodData?: ChangeShippingMethodData, options?: any) {
        return BasketApiFp(this.configuration).changeShippingMethod(changeShippingMethodData, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Removes the given position from the basket
     * @param {DeletePositionData} [deletePositionData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasketApi
     */
    public deletePosition(deletePositionData?: DeletePositionData, options?: any) {
        return BasketApiFp(this.configuration).deletePosition(deletePositionData, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Edits the given position's amount
     * @param {EditPositionAmountData} [editPositionAmountData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasketApi
     */
    public editPositionAmount(editPositionAmountData?: EditPositionAmountData, options?: any) {
        return BasketApiFp(this.configuration).editPositionAmount(editPositionAmountData, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Returns an object containing all information about the user's basket
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BasketApi
     */
    public getBasket(options?: any) {
        return BasketApiFp(this.configuration).getBasket(options)(this.fetch, this.basePath);
    }

}

/**
 * CodeApi - fetch parameter creator
 * @export
 */
export const CodeApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {RedeemCodesData} [redeemCodesData] 
         * @param {string} [altchaToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemCodes(redeemCodesData?: RedeemCodesData, altchaToken?: string, options: any = {}): FetchArgs {
            const localVarPath = `/api/redeemCodes`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (altchaToken !== undefined) {
                localVarQueryParameter['altchaToken'] = altchaToken;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RedeemCodesData" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(redeemCodesData || {}) : (redeemCodesData || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CodeApi - functional programming interface
 * @export
 */
export const CodeApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {RedeemCodesData} [redeemCodesData] 
         * @param {string} [altchaToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemCodes(redeemCodesData?: RedeemCodesData, altchaToken?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<boolean>> {
            const localVarFetchArgs = CodeApiFetchParamCreator(configuration).redeemCodes(redeemCodesData, altchaToken, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * CodeApi - factory interface
 * @export
 */
export const CodeApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {RedeemCodesData} [redeemCodesData] 
         * @param {string} [altchaToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        redeemCodes(redeemCodesData?: RedeemCodesData, altchaToken?: string, options?: any) {
            return CodeApiFp(configuration).redeemCodes(redeemCodesData, altchaToken, options)(fetch, basePath);
        },
    };
};

/**
 * CodeApi - object-oriented interface
 * @export
 * @class CodeApi
 * @extends {BaseAPI}
 */
export class CodeApi extends BaseAPI {
    /**
     * 
     * @param {RedeemCodesData} [redeemCodesData] 
     * @param {string} [altchaToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CodeApi
     */
    public redeemCodes(redeemCodesData?: RedeemCodesData, altchaToken?: string, options?: any) {
        return CodeApiFp(this.configuration).redeemCodes(redeemCodesData, altchaToken, options)(this.fetch, this.basePath);
    }

}

/**
 * CouponApi - fetch parameter creator
 * @export
 */
export const CouponApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoupons(options: any = {}): FetchArgs {
            const localVarPath = `/api/coupons`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CouponApi - functional programming interface
 * @export
 */
export const CouponApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoupons(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<CouponDto>> {
            const localVarFetchArgs = CouponApiFetchParamCreator(configuration).getCoupons(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * CouponApi - factory interface
 * @export
 */
export const CouponApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCoupons(options?: any) {
            return CouponApiFp(configuration).getCoupons(options)(fetch, basePath);
        },
    };
};

/**
 * CouponApi - object-oriented interface
 * @export
 * @class CouponApi
 * @extends {BaseAPI}
 */
export class CouponApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponApi
     */
    public getCoupons(options?: any) {
        return CouponApiFp(this.configuration).getCoupons(options)(this.fetch, this.basePath);
    }

}

/**
 * CustomerApi - fetch parameter creator
 * @export
 */
export const CustomerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns whether the current session is associated with a Newsletter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isCustomerRegistered(options: any = {}): FetchArgs {
            const localVarPath = `/api/customer/customerRegistered`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CustomerProfileDto} [customerProfileDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerCustomer(customerProfileDto?: CustomerProfileDto, options: any = {}): FetchArgs {
            const localVarPath = `/api/registerCustomer`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CustomerProfileDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(customerProfileDto || {}) : (customerProfileDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deletes the given customer profile (= unsubscribes from the newsletter)
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregisterCustomer(token: string, options: any = {}): FetchArgs {
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token','Required parameter token was null or undefined when calling unregisterCustomer.');
            }
            const localVarPath = `/api/unregisterCustomer/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomerApi - functional programming interface
 * @export
 */
export const CustomerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns whether the current session is associated with a Newsletter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isCustomerRegistered(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<boolean> {
            const localVarFetchArgs = CustomerApiFetchParamCreator(configuration).isCustomerRegistered(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {CustomerProfileDto} [customerProfileDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerCustomer(customerProfileDto?: CustomerProfileDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CustomerApiFetchParamCreator(configuration).registerCustomer(customerProfileDto, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Deletes the given customer profile (= unsubscribes from the newsletter)
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregisterCustomer(token: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CustomerApiFetchParamCreator(configuration).unregisterCustomer(token, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * CustomerApi - factory interface
 * @export
 */
export const CustomerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Returns whether the current session is associated with a Newsletter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isCustomerRegistered(options?: any) {
            return CustomerApiFp(configuration).isCustomerRegistered(options)(fetch, basePath);
        },
        /**
         * 
         * @param {CustomerProfileDto} [customerProfileDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerCustomer(customerProfileDto?: CustomerProfileDto, options?: any) {
            return CustomerApiFp(configuration).registerCustomer(customerProfileDto, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Deletes the given customer profile (= unsubscribes from the newsletter)
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregisterCustomer(token: string, options?: any) {
            return CustomerApiFp(configuration).unregisterCustomer(token, options)(fetch, basePath);
        },
    };
};

/**
 * CustomerApi - object-oriented interface
 * @export
 * @class CustomerApi
 * @extends {BaseAPI}
 */
export class CustomerApi extends BaseAPI {
    /**
     * 
     * @summary Returns whether the current session is associated with a Newsletter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public isCustomerRegistered(options?: any) {
        return CustomerApiFp(this.configuration).isCustomerRegistered(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {CustomerProfileDto} [customerProfileDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public registerCustomer(customerProfileDto?: CustomerProfileDto, options?: any) {
        return CustomerApiFp(this.configuration).registerCustomer(customerProfileDto, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Deletes the given customer profile (= unsubscribes from the newsletter)
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomerApi
     */
    public unregisterCustomer(token: string, options?: any) {
        return CustomerApiFp(this.configuration).unregisterCustomer(token, options)(this.fetch, this.basePath);
    }

}

/**
 * DownloadPackageApi - fetch parameter creator
 * @export
 */
export const DownloadPackageApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} code 
         * @param {number} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImage(code: string, imageId: number, options: any = {}): FetchArgs {
            // verify required parameter 'code' is not null or undefined
            if (code === null || code === undefined) {
                throw new RequiredError('code','Required parameter code was null or undefined when calling downloadImage.');
            }
            // verify required parameter 'imageId' is not null or undefined
            if (imageId === null || imageId === undefined) {
                throw new RequiredError('imageId','Required parameter imageId was null or undefined when calling downloadImage.');
            }
            const localVarPath = `/api/download/{code}/image/{imageId}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)))
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadZip(code: string, options: any = {}): FetchArgs {
            // verify required parameter 'code' is not null or undefined
            if (code === null || code === undefined) {
                throw new RequiredError('code','Required parameter code was null or undefined when calling downloadZip.');
            }
            const localVarPath = `/api/download/{code}/zip`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns an image corresponding to the given id
         * @param {string} code 
         * @param {number} imageId 
         * @param {'small' | 'large'} size 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviewImage(code: string, imageId: number, size: 'small' | 'large', options: any = {}): FetchArgs {
            // verify required parameter 'code' is not null or undefined
            if (code === null || code === undefined) {
                throw new RequiredError('code','Required parameter code was null or undefined when calling getPreviewImage.');
            }
            // verify required parameter 'imageId' is not null or undefined
            if (imageId === null || imageId === undefined) {
                throw new RequiredError('imageId','Required parameter imageId was null or undefined when calling getPreviewImage.');
            }
            // verify required parameter 'size' is not null or undefined
            if (size === null || size === undefined) {
                throw new RequiredError('size','Required parameter size was null or undefined when calling getPreviewImage.');
            }
            const localVarPath = `/api/download/{code}/previewImage/{imageId}/{size}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)))
                .replace(`{${"imageId"}}`, encodeURIComponent(String(imageId)))
                .replace(`{${"size"}}`, encodeURIComponent(String(size)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listImages(code: string, options: any = {}): FetchArgs {
            // verify required parameter 'code' is not null or undefined
            if (code === null || code === undefined) {
                throw new RequiredError('code','Required parameter code was null or undefined when calling listImages.');
            }
            const localVarPath = `/api/download/{code}/list`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DownloadPackageApi - functional programming interface
 * @export
 */
export const DownloadPackageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} code 
         * @param {number} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImage(code: string, imageId: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = DownloadPackageApiFetchParamCreator(configuration).downloadImage(code, imageId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadZip(code: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = DownloadPackageApiFetchParamCreator(configuration).downloadZip(code, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Returns an image corresponding to the given id
         * @param {string} code 
         * @param {number} imageId 
         * @param {'small' | 'large'} size 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviewImage(code: string, imageId: number, size: 'small' | 'large', options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = DownloadPackageApiFetchParamCreator(configuration).getPreviewImage(code, imageId, size, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listImages(code: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ImageDto>> {
            const localVarFetchArgs = DownloadPackageApiFetchParamCreator(configuration).listImages(code, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DownloadPackageApi - factory interface
 * @export
 */
export const DownloadPackageApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} code 
         * @param {number} imageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadImage(code: string, imageId: number, options?: any) {
            return DownloadPackageApiFp(configuration).downloadImage(code, imageId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadZip(code: string, options?: any) {
            return DownloadPackageApiFp(configuration).downloadZip(code, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Returns an image corresponding to the given id
         * @param {string} code 
         * @param {number} imageId 
         * @param {'small' | 'large'} size 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPreviewImage(code: string, imageId: number, size: 'small' | 'large', options?: any) {
            return DownloadPackageApiFp(configuration).getPreviewImage(code, imageId, size, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listImages(code: string, options?: any) {
            return DownloadPackageApiFp(configuration).listImages(code, options)(fetch, basePath);
        },
    };
};

/**
 * DownloadPackageApi - object-oriented interface
 * @export
 * @class DownloadPackageApi
 * @extends {BaseAPI}
 */
export class DownloadPackageApi extends BaseAPI {
    /**
     * 
     * @param {string} code 
     * @param {number} imageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadPackageApi
     */
    public downloadImage(code: string, imageId: number, options?: any) {
        return DownloadPackageApiFp(this.configuration).downloadImage(code, imageId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadPackageApi
     */
    public downloadZip(code: string, options?: any) {
        return DownloadPackageApiFp(this.configuration).downloadZip(code, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Returns an image corresponding to the given id
     * @param {string} code 
     * @param {number} imageId 
     * @param {'small' | 'large'} size 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadPackageApi
     */
    public getPreviewImage(code: string, imageId: number, size: 'small' | 'large', options?: any) {
        return DownloadPackageApiFp(this.configuration).getPreviewImage(code, imageId, size, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DownloadPackageApi
     */
    public listImages(code: string, options?: any) {
        return DownloadPackageApiFp(this.configuration).listImages(code, options)(this.fetch, this.basePath);
    }

}

/**
 * ImageApi - fetch parameter creator
 * @export
 */
export const ImageApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Adds the given image to the list of favorites
         * @param {string} uniqueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavoriteImage(uniqueId: string, options: any = {}): FetchArgs {
            // verify required parameter 'uniqueId' is not null or undefined
            if (uniqueId === null || uniqueId === undefined) {
                throw new RequiredError('uniqueId','Required parameter uniqueId was null or undefined when calling addFavoriteImage.');
            }
            const localVarPath = `/api/image/{uniqueId}/addFavorite`
                .replace(`{${"uniqueId"}}`, encodeURIComponent(String(uniqueId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns an image corresponding to the given id
         * @param {string} id 
         * @param {'small' | 'large'} size 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImage(id: string, size: 'small' | 'large', filter?: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getImage.');
            }
            // verify required parameter 'size' is not null or undefined
            if (size === null || size === undefined) {
                throw new RequiredError('size','Required parameter size was null or undefined when calling getImage.');
            }
            const localVarPath = `/api/image/{id}/{size}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"size"}}`, encodeURIComponent(String(size)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns all images the user has permission for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImages(options: any = {}): FetchArgs {
            const localVarPath = `/api/images`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Removes the given image from the list of favorites
         * @param {string} uniqueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFavoriteImage(uniqueId: string, options: any = {}): FetchArgs {
            // verify required parameter 'uniqueId' is not null or undefined
            if (uniqueId === null || uniqueId === undefined) {
                throw new RequiredError('uniqueId','Required parameter uniqueId was null or undefined when calling removeFavoriteImage.');
            }
            const localVarPath = `/api/image/{uniqueId}/removeFavorite`
                .replace(`{${"uniqueId"}}`, encodeURIComponent(String(uniqueId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImageApi - functional programming interface
 * @export
 */
export const ImageApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Adds the given image to the list of favorites
         * @param {string} uniqueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavoriteImage(uniqueId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ImageApiFetchParamCreator(configuration).addFavoriteImage(uniqueId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Returns an image corresponding to the given id
         * @param {string} id 
         * @param {'small' | 'large'} size 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImage(id: string, size: 'small' | 'large', filter?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ImageApiFetchParamCreator(configuration).getImage(id, size, filter, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Returns all images the user has permission for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImages(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ImageCollectionDto> {
            const localVarFetchArgs = ImageApiFetchParamCreator(configuration).getImages(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Removes the given image from the list of favorites
         * @param {string} uniqueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFavoriteImage(uniqueId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ImageApiFetchParamCreator(configuration).removeFavoriteImage(uniqueId, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ImageApi - factory interface
 * @export
 */
export const ImageApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Adds the given image to the list of favorites
         * @param {string} uniqueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavoriteImage(uniqueId: string, options?: any) {
            return ImageApiFp(configuration).addFavoriteImage(uniqueId, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Returns an image corresponding to the given id
         * @param {string} id 
         * @param {'small' | 'large'} size 
         * @param {string} [filter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImage(id: string, size: 'small' | 'large', filter?: string, options?: any) {
            return ImageApiFp(configuration).getImage(id, size, filter, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Returns all images the user has permission for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImages(options?: any) {
            return ImageApiFp(configuration).getImages(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Removes the given image from the list of favorites
         * @param {string} uniqueId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFavoriteImage(uniqueId: string, options?: any) {
            return ImageApiFp(configuration).removeFavoriteImage(uniqueId, options)(fetch, basePath);
        },
    };
};

/**
 * ImageApi - object-oriented interface
 * @export
 * @class ImageApi
 * @extends {BaseAPI}
 */
export class ImageApi extends BaseAPI {
    /**
     * 
     * @summary Adds the given image to the list of favorites
     * @param {string} uniqueId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageApi
     */
    public addFavoriteImage(uniqueId: string, options?: any) {
        return ImageApiFp(this.configuration).addFavoriteImage(uniqueId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Returns an image corresponding to the given id
     * @param {string} id 
     * @param {'small' | 'large'} size 
     * @param {string} [filter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageApi
     */
    public getImage(id: string, size: 'small' | 'large', filter?: string, options?: any) {
        return ImageApiFp(this.configuration).getImage(id, size, filter, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Returns all images the user has permission for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageApi
     */
    public getImages(options?: any) {
        return ImageApiFp(this.configuration).getImages(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Removes the given image from the list of favorites
     * @param {string} uniqueId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImageApi
     */
    public removeFavoriteImage(uniqueId: string, options?: any) {
        return ImageApiFp(this.configuration).removeFavoriteImage(uniqueId, options)(this.fetch, this.basePath);
    }

}

/**
 * LocaleApi - fetch parameter creator
 * @export
 */
export const LocaleApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns all message translations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessages(options: any = {}): FetchArgs {
            const localVarPath = `/api/locale`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LocaleApi - functional programming interface
 * @export
 */
export const LocaleApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns all message translations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessages(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = LocaleApiFetchParamCreator(configuration).getMessages(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * LocaleApi - factory interface
 * @export
 */
export const LocaleApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Returns all message translations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessages(options?: any) {
            return LocaleApiFp(configuration).getMessages(options)(fetch, basePath);
        },
    };
};

/**
 * LocaleApi - object-oriented interface
 * @export
 * @class LocaleApi
 * @extends {BaseAPI}
 */
export class LocaleApi extends BaseAPI {
    /**
     * 
     * @summary Returns all message translations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LocaleApi
     */
    public getMessages(options?: any) {
        return LocaleApiFp(this.configuration).getMessages(options)(this.fetch, this.basePath);
    }

}

/**
 * OrderApi - fetch parameter creator
 * @export
 */
export const OrderApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns an qr code image to pay the order
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankTransferQrCode(token: string, options: any = {}): FetchArgs {
            // verify required parameter 'token' is not null or undefined
            if (token === null || token === undefined) {
                throw new RequiredError('token','Required parameter token was null or undefined when calling getBankTransferQrCode.');
            }
            const localVarPath = `/api/order/{token}/bank-transfer/qr-code`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a Stripe payment intent code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentIntent(options: any = {}): FetchArgs {
            const localVarPath = `/api/order/getPaymentIntent`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Places an order
         * @param {PlaceOrderData} [placeOrderData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeOrder(placeOrderData?: PlaceOrderData, options: any = {}): FetchArgs {
            const localVarPath = `/api/order/place`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"PlaceOrderData" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(placeOrderData || {}) : (placeOrderData || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Registers a source for webhook events
         * @param {RegisterPaymentSourceData} [registerPaymentSourceData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPaymentSource(registerPaymentSourceData?: RegisterPaymentSourceData, options: any = {}): FetchArgs {
            const localVarPath = `/api/order/registerPaymentSource`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RegisterPaymentSourceData" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(registerPaymentSourceData || {}) : (registerPaymentSourceData || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sends payment details to the server
         * @param {VerifyPaymentDataDto} [verifyPaymentDataDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPayment(verifyPaymentDataDto?: VerifyPaymentDataDto, options: any = {}): FetchArgs {
            const localVarPath = `/api/order/verifyPayment`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"VerifyPaymentDataDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(verifyPaymentDataDto || {}) : (verifyPaymentDataDto || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderApi - functional programming interface
 * @export
 */
export const OrderApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns an qr code image to pay the order
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankTransferQrCode(token: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = OrderApiFetchParamCreator(configuration).getBankTransferQrCode(token, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Returns a Stripe payment intent code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentIntent(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<StripePaymentInformationDto> {
            const localVarFetchArgs = OrderApiFetchParamCreator(configuration).getPaymentIntent(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Places an order
         * @param {PlaceOrderData} [placeOrderData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeOrder(placeOrderData?: PlaceOrderData, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OrderConfirmationDto> {
            const localVarFetchArgs = OrderApiFetchParamCreator(configuration).placeOrder(placeOrderData, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Registers a source for webhook events
         * @param {RegisterPaymentSourceData} [registerPaymentSourceData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPaymentSource(registerPaymentSourceData?: RegisterPaymentSourceData, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = OrderApiFetchParamCreator(configuration).registerPaymentSource(registerPaymentSourceData, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Sends payment details to the server
         * @param {VerifyPaymentDataDto} [verifyPaymentDataDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPayment(verifyPaymentDataDto?: VerifyPaymentDataDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<OrderConfirmationDto> {
            const localVarFetchArgs = OrderApiFetchParamCreator(configuration).verifyPayment(verifyPaymentDataDto, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * OrderApi - factory interface
 * @export
 */
export const OrderApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Returns an qr code image to pay the order
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankTransferQrCode(token: string, options?: any) {
            return OrderApiFp(configuration).getBankTransferQrCode(token, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Returns a Stripe payment intent code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPaymentIntent(options?: any) {
            return OrderApiFp(configuration).getPaymentIntent(options)(fetch, basePath);
        },
        /**
         * 
         * @summary Places an order
         * @param {PlaceOrderData} [placeOrderData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placeOrder(placeOrderData?: PlaceOrderData, options?: any) {
            return OrderApiFp(configuration).placeOrder(placeOrderData, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Registers a source for webhook events
         * @param {RegisterPaymentSourceData} [registerPaymentSourceData] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPaymentSource(registerPaymentSourceData?: RegisterPaymentSourceData, options?: any) {
            return OrderApiFp(configuration).registerPaymentSource(registerPaymentSourceData, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Sends payment details to the server
         * @param {VerifyPaymentDataDto} [verifyPaymentDataDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyPayment(verifyPaymentDataDto?: VerifyPaymentDataDto, options?: any) {
            return OrderApiFp(configuration).verifyPayment(verifyPaymentDataDto, options)(fetch, basePath);
        },
    };
};

/**
 * OrderApi - object-oriented interface
 * @export
 * @class OrderApi
 * @extends {BaseAPI}
 */
export class OrderApi extends BaseAPI {
    /**
     * 
     * @summary Returns an qr code image to pay the order
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public getBankTransferQrCode(token: string, options?: any) {
        return OrderApiFp(this.configuration).getBankTransferQrCode(token, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Returns a Stripe payment intent code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public getPaymentIntent(options?: any) {
        return OrderApiFp(this.configuration).getPaymentIntent(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Places an order
     * @param {PlaceOrderData} [placeOrderData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public placeOrder(placeOrderData?: PlaceOrderData, options?: any) {
        return OrderApiFp(this.configuration).placeOrder(placeOrderData, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Registers a source for webhook events
     * @param {RegisterPaymentSourceData} [registerPaymentSourceData] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public registerPaymentSource(registerPaymentSourceData?: RegisterPaymentSourceData, options?: any) {
        return OrderApiFp(this.configuration).registerPaymentSource(registerPaymentSourceData, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Sends payment details to the server
     * @param {VerifyPaymentDataDto} [verifyPaymentDataDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public verifyPayment(verifyPaymentDataDto?: VerifyPaymentDataDto, options?: any) {
        return OrderApiFp(this.configuration).verifyPayment(verifyPaymentDataDto, options)(this.fetch, this.basePath);
    }

}

/**
 * ProductApi - fetch parameter creator
 * @export
 */
export const ProductApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the product image
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductImage(id: number, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getProductImage.');
            }
            const localVarPath = `/api/product/{id}/image`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns a collection of all available products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(options: any = {}): FetchArgs {
            const localVarPath = `/api/products`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductApi - functional programming interface
 * @export
 */
export const ProductApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the product image
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductImage(id: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = ProductApiFetchParamCreator(configuration).getProductImage(id, options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @summary Returns a collection of all available products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ProductDto>> {
            const localVarFetchArgs = ProductApiFetchParamCreator(configuration).getProducts(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ProductApi - factory interface
 * @export
 */
export const ProductApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Returns the product image
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductImage(id: number, options?: any) {
            return ProductApiFp(configuration).getProductImage(id, options)(fetch, basePath);
        },
        /**
         * 
         * @summary Returns a collection of all available products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProducts(options?: any) {
            return ProductApiFp(configuration).getProducts(options)(fetch, basePath);
        },
    };
};

/**
 * ProductApi - object-oriented interface
 * @export
 * @class ProductApi
 * @extends {BaseAPI}
 */
export class ProductApi extends BaseAPI {
    /**
     * 
     * @summary Returns the product image
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getProductImage(id: number, options?: any) {
        return ProductApiFp(this.configuration).getProductImage(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @summary Returns a collection of all available products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getProducts(options?: any) {
        return ProductApiFp(this.configuration).getProducts(options)(this.fetch, this.basePath);
    }

}

/**
 * ProductCategoryApi - fetch parameter creator
 * @export
 */
export const ProductCategoryApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns all product categories that contain active products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCategories(options: any = {}): FetchArgs {
            const localVarPath = `/api/productCategories`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductCategoryApi - functional programming interface
 * @export
 */
export const ProductCategoryApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns all product categories that contain active products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCategories(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<ProductCategoryDto>> {
            const localVarFetchArgs = ProductCategoryApiFetchParamCreator(configuration).getProductCategories(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ProductCategoryApi - factory interface
 * @export
 */
export const ProductCategoryApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Returns all product categories that contain active products
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductCategories(options?: any) {
            return ProductCategoryApiFp(configuration).getProductCategories(options)(fetch, basePath);
        },
    };
};

/**
 * ProductCategoryApi - object-oriented interface
 * @export
 * @class ProductCategoryApi
 * @extends {BaseAPI}
 */
export class ProductCategoryApi extends BaseAPI {
    /**
     * 
     * @summary Returns all product categories that contain active products
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductCategoryApi
     */
    public getProductCategories(options?: any) {
        return ProductCategoryApiFp(this.configuration).getProductCategories(options)(this.fetch, this.basePath);
    }

}

/**
 * StaticFileApi - fetch parameter creator
 * @export
 */
export const StaticFileApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the logo as image file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogo(options: any = {}): FetchArgs {
            const localVarPath = `/api/logo`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StaticFileApi - functional programming interface
 * @export
 */
export const StaticFileApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Returns the logo as image file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogo(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = StaticFileApiFetchParamCreator(configuration).getLogo(options);
            return (fetch: FetchAPI = portableFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * StaticFileApi - factory interface
 * @export
 */
export const StaticFileApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @summary Returns the logo as image file
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLogo(options?: any) {
            return StaticFileApiFp(configuration).getLogo(options)(fetch, basePath);
        },
    };
};

/**
 * StaticFileApi - object-oriented interface
 * @export
 * @class StaticFileApi
 * @extends {BaseAPI}
 */
export class StaticFileApi extends BaseAPI {
    /**
     * 
     * @summary Returns the logo as image file
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StaticFileApi
     */
    public getLogo(options?: any) {
        return StaticFileApiFp(this.configuration).getLogo(options)(this.fetch, this.basePath);
    }

}

